module.exports = __webpack_public_path__ + "media/images/writer/home/icon-effect-2a448a7164a74f61fa4cddf36e4e02ab.svg";